<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :items-per-page="15"
    :search="search"
    :custom-filter="$options.localeIncludes"
    :loading="loading"
    :loading-text="$t('general.loading')"
    :sort-by="['creationDate']"
    :sort-desc="[true]"
    @input="$emit('update:selected', $event)"
  >
    <template v-slot:[`item.status`]="{ item }">
      <span
        v-if="item.status"
        class="rounded-pill py-1 px-2 white--text"
        :class="$t(`tokens.demands.status.${item.status}.color`)"
        v-text="$t(`tokens.demands.status.${item.status}.label`)"
      />
    </template>
    <template v-slot:[`item.tokenNumber`]="{ item }">
      <span
        class="font-weight-medium mr-5"
        v-text="item.tokenNumber"
      />
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <ag-confirm-dialog
        v-if="cancellable(item)"
        :title="$t('general.confirmation')"
        :message="$t('tokens.demands.cancelConfirm')"
        :cancel-label="$t('general.no')"
        :confirm-label="$t('general.yes')"
        validation-btn-color="error"
        @confirm="cancel(item)"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :loading="loadingCancel"
            :disabled="loadingCancel"
            color="error"
            class="mr-1"
            small
            append
            v-bind="attrs"
            v-on="on"
            v-text="$t('general.cancel')"
          />
        </template>
      </ag-confirm-dialog>

      <v-btn
        color="accent"
        small
        append
        :to="item.id"
        v-text="$t('general.open')"
      />
    </template>
  </v-data-table>
</template>

<script>
import Helpers from 'src/utils/helpers'
import AgConfirmDialog from 'src/components/common/AgConfirmDialog'

export default {
  name: 'TokensDemandList',
  components: {
    AgConfirmDialog,
  },
  props: {
    value: {
      type: Array,
      default: () => ([]),
    },
    search: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    cancellable: {
      type: Function,
      default: () => false,
    },
  },
  data () {
    return {
      loadingCancel: false,
    }
  },
  computed: {
    headers () {
      return [
        {
          text: this.$t('tokens.demands.fields.creationDate'),
          value: 'creationDate',
        },
        {
          text: this.$t('tokens.demands.fields.createdBy'),
          value: 'createdBy',
          align: 'center',
        },
        {
          text: this.$t('tokens.demands.fields.status'),
          value: 'status',
          align: 'center',
        },
        {
          text: this.$t('tokens.demands.fields.tokenNumber'),
          value: 'tokenNumber',
          align: 'right',
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
          filterable: false,
          align: 'right',
          width: '200px',
        },
      ]
    },
    items () {
      return this.value.map(item => ({
        id: item.id,
        creationDate: Helpers.formatDate(item.creationDate, this.$t('date.dateAndTime')),
        createdBy: `${item.createdBy.firstName} ${item.createdBy.lastName}`,
        status: item.status,
        tokenNumber: item.tokenNumber.toLocaleString(),
      }))
    },
  },
  methods: {
    async cancel (item) {
      this.loadingCancel = true
      if (this.$listeners.cancel) {
        await this.$listeners.cancel(item.id)
      }
      this.loadingCancel = false
    },
  },
  localeIncludes: Helpers.localeIncludes,
}
</script>
